import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { helpHttp } from "../../helpers/helpHttp";
import { BASE_API, LABELTEXT, LABELTEXT_S } from "../../api/Globals";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
// import useScanDetection from "use-scan-detection";
import CustomSelect from "../select/CustomSelect";
import { Sidebar } from "primereact/sidebar";
import ScannerEntrega from "../../pages/entrega/barcode";
import { storage } from "../../helpers/storage";

let emptyArr = { serie: "" };

const TransaccionTablet = (
    {
        visible = false,
        onHide = () => { },
        status = null,
        abrirAlta = () => { },
        loading
    }
) => {

    const [selectedTablets, setSelectedTablets] = useState([])
    const [numTablets, setNumTablets] = useState(0)
    const [lstBaseDatos, setLstBaseDatos] = useState([])
    const [lstAlmacenCT, setLstAlmacenCT] = useState([])
    const [idTiendaDestino, setIdTiendaDestino] = useState(null);
    const [observaciones, setObservaciones] = useState('');
    const [tablet, setTablet] = useState(emptyArr)
    const [loading1, setLoading1] = useState(true)
    const [lodingReporte, setLoadingReporte] = useState(false)
    const [displayDalogAviso, setDisplayDialogAviso] = useState(false);
    const [scannerDialog, setScannerDialog] = useState(false);
    const usuario = storage.get('usuario')
    const [reporte, setReporte] = useState(null)
    const toast = useRef(null);


    useEffect(() => {

        setLoading1(true)
    }, [loading])


    useEffect(() => {
        lstAlmacenCT.forEach(x => {
            if (x.IdTienda === idTiendaDestino) {
                x.AlumnosFaltantes && setNumTablets(x.TotalTabletas - x.TotalTabletasEntregadasaCT - selectedTablets.length)

            }

        })
    }, [idTiendaDestino, loading])

    useEffect(() => {
        const url = (`${BASE_API}Tablets/postAlmObtenerlistadoTabletsparaEntrega`);

        if (visible !== false) {
            // Endpoint para listar las tablets pendientes en almacen
            helpHttp().post(url, {
                body: {
                    idUsuario: storage.get('id'),
                    idEstatus: 2,
                    idTienda: null,
                    idAlmacen: null,
                    parametrosExtra: "S"
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                const response = res.ITEMS.map(x => {
                    let item = {
                        label: parseInt(process.env.REACT_APP_SISTEMA) !== 1 ? x.serie : x.CodigoPrenda + x.CodigoTalla + x.serie,
                        value: { ...x }
                    }
                    return item
                })
                // console.log(response)
                setLstBaseDatos(response);
            })

            //Endpoint que lista los almacenes reginales
            const url2 = (`${BASE_API}Tablets/postSpdAlmListarAlmacenCT`)
            helpHttp().post(url2, {
                body: {
                    idTiendaAlmacen: null,
                    idTipoMovimiento: parseInt(process.env.REACT_APP_SISTEMA) === 1 && status == 3 ? 10 : (status === 3 ? 1 : 2), // el id cambia segun el tipo de movimineto
                    idUsuario: storage.get('id')
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {

                if (res.ITEMS != null && res.ITEMS.length > 0) {
                    setLstAlmacenCT(res.ITEMS);
                    setIdTiendaDestino(res.ITEMS[0].IdTienda)
                    // console.log(res.ITEMS[0])
                }
                setLoading1(false)

            })
        }
    }, [visible])

    // useScanDetection({
    //     onComplete: (code) => { setTablet({ ...tablet, serie: code }) },
    // });

    const seleccionarTabletas = async (e) => {
        e.preventDefault();

        if (numTablets > 0 || status === 6 || status === 7 || parseInt(process.env.REACT_APP_SISTEMA) === 1) {
            if (lstBaseDatos.length !== 0) {
                const arr = lstBaseDatos
                const res = lstBaseDatos.find(item => item.value.serie === tablet.serie);
                const response = await helpHttp().post(`${BASE_API}Pip/spdObtenerFolioPrendaTIT`, {
                    body: {
                        CodigoPrenda: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? tablet.serie.slice(0, 2) : "09",
                        CodigoTalla: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? tablet.serie.slice(2, 5) : "111",
                        Serie: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? tablet.serie.slice(5) : tablet.serie,
                        IdAlumno: -1
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                })

                if (response.ITEMS.Serie !== null) {
                    if (res !== undefined) {
                        let arrSel = selectedTablets
                        const index = arr.indexOf(res);
                        const x = arr.splice(index, 1)

                        arrSel.unshift(x[0].value)
                        setLstBaseDatos(arr)
                        setNumTablets(status === 3 ? numTablets - 1 : numTablets + 1)
                        // console.log(arrSel)
                        setSelectedTablets(arrSel)
                    } else {
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `${LABELTEXT_S} no encontrado en este almacén.`, life: 3000 })
                    }
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: response.ITEMS.Mensaje, life: 3000 })
                }
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Ya no hay ${LABELTEXT.toLowerCase()} en el almacén`, life: 3000 })
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Se ha alcanzado el máximo de ${LABELTEXT.toLowerCase()} por entregar en este CT.`, life: 3000 })
        }
        setTablet(emptyArr)
    }

    const seleccionarTabletasQR = async (serie) => {

        if (numTablets > 0 || status === 6 || status === 7 || parseInt(process.env.REACT_APP_SISTEMA) === 1) {
            if (lstBaseDatos.length !== 0) {
                const arr = lstBaseDatos
                const res = lstBaseDatos.find(item => item.value.serie === serie.slice(5));
                const response = await helpHttp().post(`${BASE_API}Pip/spdObtenerFolioPrendaTIT`, {
                    body: {
                        CodigoPrenda: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? serie.slice(0, 2) : "09",
                        CodigoTalla: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? serie.slice(2, 5) : "111",
                        Serie: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? serie.slice(5) : serie,
                        IdAlumno: -1
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                })
                if (response.ITEMS.Serie !== null) {
                    if (res !== undefined) {
                        let arrSel = selectedTablets
                        const index = arr.indexOf(res);
                        const x = arr.splice(index, 1)

                        arrSel.unshift(x[0].value)
                        setLstBaseDatos(arr)
                        setNumTablets(status === 3 ? numTablets - 1 : numTablets + 1)
                        // console.log(arrSel)
                        setSelectedTablets(arrSel)
                    } else {
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `${LABELTEXT_S} escaneado o no se encuentra en almacén.`, life: 3000 })
                    }
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: response.ITEMS.Mensaje, life: 3000 })
                }
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Ya no hay ${LABELTEXT.toLowerCase()} en el almacén`, life: 3000 })
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Se ha alcanzado el máximo de ${LABELTEXT.toLowerCase()} por entregar en este CT.`, life: 3000 })
        }
        setTablet(emptyArr)
    }

    const seleccionarTabletas2 = async (e) => {
        e.preventDefault();
        const tableta = tablet.serie.trim()
        // console.log('r1', res.label.slice(5).toString())
        // console.log('bd', lstBaseDatos)
        // console.log('bd2', lstBaseDatos.find(item => item.value.CodigoPrenda + item.value.CodigoTalla + item.value.serie === tablet.serie))
        if (tableta.length === 12) {
            const response = await helpHttp().post(`${BASE_API}Pip/spdObtenerFolioPrendaTIT2`, {
                body: {
                    CodigoPrenda: tableta.slice(0, 2),
                    CodigoTalla: tableta.slice(2, 5),
                    Serie: tableta.slice(5),
                    IdAlumno: -1
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            })

            if (response.ITEMS.success !== false) {
                // if (res !== undefined) {
                let sumaPrendas = lstAlmacenCT
                let arrSel = selectedTablets
                // console.log('index', index)
                // console.log('arrSel', arrSel)
                // console.log('repetido', !(arrSel.some(obj => response.ITEMS.SerieEntregado === obj.CodigoPrenda + obj.CodigoTalla + obj.serie)))
                // console.log('serie', arrSel.map(obj => { return obj.CodigoPrenda + obj.CodigoTalla + obj.serie }))
                if (!(arrSel.some(obj => response.ITEMS.SerieEntregado === obj.CodigoPrenda + obj.CodigoTalla + obj.serie))) {
                    if (status === 3) {
                        sumaPrendas.forEach(x => {
                            if (x.IdTienda === idTiendaDestino) {
                                let Json = JSON.parse(x.JsonPrendas)
                                let banderaPT = true
                                // console.log('cp', arr[0].value.CodigoPrenda)

                                // console.log('cp2', arr[0].value.CodigoTalla)

                                //console.log('if', arr.splice(index, 1)[0].value.CodigoPrenda + arr.splice(index, 1)[0].value.CodigoTalla)
                                // console.log('x', x)
                                Json.forEach(prenda => {
                                    // console.log('arr', arr[index])
                                    if (prenda.CodigoPT === response.ITEMS.SerieEntregado.slice(0, 5)) {
                                        banderaPT = false
                                        // console.log('ss', arr[0].value.serie == res.label.slice(5))
                                        if (parseInt(prenda.TotalEntregado) < parseInt(prenda.Total)) {
                                            let numero = parseInt(prenda.TotalEntregado)
                                            prenda.TotalEntregado = numero + 1;

                                            // const x = arr.splice(index, 1)
                                            setLstAlmacenCT(sumaPrendas)
                                            arrSel.unshift({
                                                Prenda: response.ITEMS.Prenda,
                                                CodigoPrenda: response.ITEMS.SerieEntregado.slice(0, 2),
                                                CodigoTalla: response.ITEMS.SerieEntregado.slice(2, 5),
                                                serie: response.ITEMS.SerieEntregado.slice(5)
                                            })
                                            // setLstBaseDatos(arr)
                                            setSelectedTablets(arrSel)
                                        } else {
                                            console.log('Dom Preignon Lady Gaga')
                                            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Se ha alcanzado el numero de articulos: ${prenda.Prenda}.`, life: 3000 })
                                        }
                                    }
                                })
                                if (banderaPT === true) toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `La prenda no coincide con los requisitos de la escuela.`, life: 3000 })
                                x.JsonPrendas = JSON.stringify(Json)
                            }
                        })
                    } else {
                        arrSel.unshift({
                            Prenda: response.ITEMS.Prenda,
                            CodigoPrenda: response.ITEMS.SerieEntregado.slice(0, 2),
                            CodigoTalla: response.ITEMS.SerieEntregado.slice(2, 5),
                            serie: response.ITEMS.SerieEntregado.slice(5)
                        })
                        // setLstBaseDatos(arr)
                        setSelectedTablets(arrSel)
                    }
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Prenda escaneada anetriormente.', life: 3000 })
                }

                // setLstAlmacenCT(sumaPrendas)
                // arrSel.unshift(x[0].value)
                // setLstBaseDatos(arr)
                // setNumTablets(status === 3 ? numTablets - 1 : numTablets + 1)
                // setSelectedTablets(arrSel)
                // } else {
                //     toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `${LABELTEXT_S} no encontrado en este almacén.`, life: 3000 })
                // }
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: response.ITEMS.Mensaje, life: 3000 })
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "El número de serie debe contener 12 dígitos.", life: 3000 })
        }
        setTablet(emptyArr)
    }

    const seleccionarTabletasQR2 = async (serie) => {

        if (numTablets > 0 || status === 6 || status === 7 || parseInt(process.env.REACT_APP_SISTEMA) === 1) {
            if (serie.length === 12) {
                // if (lstBaseDatos.length !== 0) {
                // const res = lstBaseDatos.find(item => item.value.serie === serie.slice(5));
                const response = await helpHttp().post(`${BASE_API}Pip/spdObtenerFolioPrendaTIT2`, {
                    body: {
                        CodigoPrenda: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? serie.slice(0, 2) : "09",
                        CodigoTalla: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? serie.slice(2, 5) : "111",
                        Serie: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? serie.slice(5) : serie,
                        IdAlumno: -1
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                })
                if (response.ITEMS.success !== false) {
                    // if (res !== undefined) {
                    let sumaPrendas = lstAlmacenCT
                    let arrSel = selectedTablets
                    if (!(arrSel.some(obj => response.ITEMS.SerieEntregado === obj.CodigoPrenda + obj.CodigoTalla + obj.serie))) {
                        if (status === 3) {
                            sumaPrendas.forEach(x => {
                                if (x.IdTienda === idTiendaDestino) {
                                    let Json = JSON.parse(x.JsonPrendas)
                                    let banderaPT = true;
                                    Json.forEach(prenda => {
                                        if (prenda.CodigoPT === response.ITEMS.SerieEntregado.slice(0, 5)) {
                                            banderaPT = false
                                            if (parseInt(prenda.TotalEntregado) < parseInt(prenda.Total)) {
                                                let numero = parseInt(prenda.TotalEntregado)
                                                prenda.TotalEntregado = numero + 1;

                                                // const x = arr.splice(index, 1)
                                                setLstAlmacenCT(sumaPrendas)

                                                arrSel.unshift({
                                                    Prenda: response.ITEMS.Prenda,
                                                    CodigoPrenda: response.ITEMS.SerieEntregado.slice(0, 2),
                                                    CodigoTalla: response.ITEMS.SerieEntregado.slice(2, 5),
                                                    serie: response.ITEMS.SerieEntregado.slice(5)
                                                })
                                                // setLstBaseDatos(arr)
                                                // setNumTablets(status === 3 ? numTablets - 1 : numTablets + 1)
                                                // console.log(arrSel)
                                                setNumTablets(status === 3 ? numTablets - 1 : numTablets + 1)
                                                setSelectedTablets(arrSel)
                                            } else {
                                                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Se ha alcanzado el numero de articulos: ${prenda.Prenda}.`, life: 3000 })
                                            }
                                        }
                                    })
                                    if (banderaPT === true) toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `La prenda no coincide con los requisitos de la escuela.`, life: 3000 })
                                    x.JsonPrendas = JSON.stringify(Json)
                                }
                            })
                        } else {
                            arrSel.unshift({
                                Prenda: response.ITEMS.Prenda,
                                CodigoPrenda: response.ITEMS.SerieEntregado.slice(0, 2),
                                CodigoTalla: response.ITEMS.SerieEntregado.slice(2, 5),
                                serie: response.ITEMS.SerieEntregado.slice(5)
                            })
                            // setLstBaseDatos(arr)
                            // setNumTablets(status === 3 ? numTablets - 1 : numTablets + 1)
                            // console.log(arrSel)
                            setNumTablets(status === 3 ? numTablets - 1 : numTablets + 1)
                            setSelectedTablets(arrSel)
                        }
                    } else {
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Prenda escaneada anetriormente.', life: 3000 })
                    }
                    // } else {
                    //     toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `${LABELTEXT_S} escaneado o no se encuentra en almacén.`, life: 3000 })
                    // }
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: response.ITEMS.Mensaje, life: 3000 })
                }
                // } else {
                //     toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Ya no hay ${LABELTEXT.toLowerCase()} en el almacén`, life: 3000 })
                // }
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "El número de serie debe contener 12 dígitos.", life: 3000 })
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Se ha alcanzado el máximo de ${LABELTEXT.toLowerCase()} por entregar en este CT.`, life: 3000 })
        }
        setTablet(emptyArr)
    }

    const TranferirTabletas = () => {
        if (selectedTablets.length !== 0 && status !== null) {
            if (observaciones !== "") {
                const date = new Date()
                const url = (`${BASE_API}Tablets/postspdAlmAsignarTabletMasiva`)
                const Excel = selectedTablets.map(item => {
                    let items = {
                        IdEstatusAlmacen: item.IdEstatusAlmacen,
                        Lote: item.Lote,
                        Serie: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? item.CodigoPrenda + item.CodigoTalla + item.serie : "09111" + item.serie,
                        IdUsuarioOrigen: storage.get('id'),
                        IdTiendaDestino: idTiendaDestino,
                        IdTipoMovimineto: status != 7 ? 1 : 3, //si el perfil es 1 la entrega es 1 y lo demas es 2
                        IdEntrega: null,
                        Observacion: observaciones,
                        fechaRegistro: date.toISOString().split('T').join(' ').split('Z').join('')
                    }
                    return items
                })

                helpHttp().post(url, {
                    body: {
                        opcion: 'T',
                        id_EncAlmacen: null,
                        id_Estatus: status,
                        id_TareaDetAlmacen: 1,
                        TablaTablets: Excel,
                        NotificaciondeEjecucion: ""
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(res => {
                    toast.current.show({ severity: 'seccess', summary: 'Mensaje de exito', detail: 'Movimiento realizado correctamente.', life: 5000 });
                    onHide();
                    setSelectedTablets([])
                    setNumTablets(0)
                    setTablet(emptyArr);
                    setObservaciones('')
                    status !== 3 && setReporte(JSON.parse(res.ITEMS.NotificacionEjecucion));
                    status !== 3 && setDisplayDialogAviso(true)
                })
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Agregue una observación.', life: 5000 })
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Seleccionar ${LABELTEXT.toLowerCase()}.`, life: 5000 });
        }
    }

    const imprimirReporte = () => {
        if (reporte !== null) {
            setLoading1(true)
            setLoadingReporte(true)
            const url = (`${BASE_API}Reportes/postObtenerReporte`);
            helpHttp().post(url, {
                body: {
                    reporte: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? 11 : 2,
                    idUsuario: storage.get('id'),
                    Folio: reporte.FolioMov,
                    parametrosExtra: ""
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS !== false) {
                    // const blob = base64ToBlob(res.ITEMS);

                    const date = new Date()
                    var temp = 'data:application/pdf;base64,'
                        + encodeURIComponent(res.ITEMS);
                    var download = document.createElement('a')
                    download.href = temp
                    download.download = (`${usuario}_${date.toLocaleString('en-GB').slice(0, 10)}`)
                    document.body.appendChild(download)
                    download.click()
                    document.body.removeChild(download)

                    setLoadingReporte(false)
                    onHide();
                    setReporte(null)
                    setDisplayDialogAviso(false)
                }
            })
        }
    }

    const tabletDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-outlined" onClick={() => { onHide(); setSelectedTablets([]); setNumTablets(0); setTablet(emptyArr); setObservaciones('') }} />
            <Button label="Guardar" icon="pi pi-check" className="p-button" onClick={() => { parseInt(process.env.REACT_APP_SISTEMA) === 2 ? numTablets < 0 ? toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Ha excedido el límite de  ${LABELTEXT.toLowerCase()} a entregar, favor de remover.`, life: 5000 }) : TranferirTabletas() : TranferirTabletas() }} />
        </React.Fragment>
    );

    const removerTableta2 = (data) => {
        if (selectedTablets.length !== 0) {
            const arr = lstBaseDatos
            const res = selectedTablets.filter(item => item.serie !== data.serie);
            if (res !== undefined) {

                const option = {
                    label: data.serie,
                    value: { ...data }
                }
                arr.unshift(option)
                setLstBaseDatos(arr)

                setSelectedTablets(res)
                setNumTablets(numTablets + 1)
            }
            else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `La ${LABELTEXT_S.toLowerCase()} no se encuentra en este almacén.`, life: 5000 })
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Ya no hay ${LABELTEXT.toLowerCase()} en el por escanear.`, life: 3000 });
        }
    }

    const removerTableta22 = (data) => {
        // console.log(data)
        if (selectedTablets.length !== 0) {
            let sumaPrendas = lstAlmacenCT
            const arr = lstBaseDatos
            const res = selectedTablets.filter(item => item.serie !== data.serie);
            if (res !== undefined) {
                sumaPrendas.forEach(x => {
                    if (x.IdTienda === idTiendaDestino) {
                        let Json = JSON.parse(x.JsonPrendas)
                        Json.forEach(prenda => {
                            if (prenda.CodigoPT === data.CodigoPrenda + data.CodigoTalla) {
                                if (parseInt(prenda.TotalEntregado) <= parseInt(prenda.Total)) {
                                    let numero = parseInt(prenda.TotalEntregado)
                                    prenda.TotalEntregado = numero - 1;

                                    const option = {
                                        label: data.CodigoPrenda + data.CodigoTalla + data.serie,
                                        value: { ...data }
                                    }
                                    arr.unshift(option)
                                    setLstBaseDatos(arr)

                                    setSelectedTablets(res)
                                }
                            }
                        })
                        x.JsonPrendas = JSON.stringify(Json)
                    }
                })
                // setNumTablets(numTablets + 1)
            }
            else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `La ${LABELTEXT_S.toLowerCase()} no se encuentra en este almacén.`, life: 5000 })
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `Ya no hay ${LABELTEXT.toLowerCase()} en el por escanear.`, life: 3000 });
        }
    }

    const retiroBodyTemplate = (rowData) => {
        return (
            <div className="text-center">
                <Button className="p-button" rounded icon='pi pi-trash' tooltip={`Remover ${LABELTEXT.toLowerCase()}`} onClick={() => removerTableta22(rowData)} />
            </div>
        )
    }

    const selectedCT = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div>{option.Tienda}</div>
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    const optionCT = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{option.Tienda}</div>
            </div>
        );
    };

    const avisoFooterTemplate = () => {
        return (
            <React.Fragment>
                <Button label='Aceptar' loading={lodingReporte} className="p-button" onClick={() => imprimirReporte()} />
            </React.Fragment>
        );
    }

    const scannerFooterTemplate = () => {
        return (
            <div className="flex justify-content-end">
                <Button className="p-button-outlined" label='Cancelar' icon='pi pi-times' onClick={() => setScannerDialog(!scannerDialog)} />
            </div>
        )
    }

    const serieConcatenada = (rowData) => {
        return <label>{parseInt(process.env.REACT_APP_SISTEMA) === 1 ? rowData.CodigoPrenda + rowData.CodigoTalla + rowData.serie : rowData.serie}</label>
    }


    return (
        <>
            <Dialog visible={visible} style={{ width: '80%' }} header={status === 6 ? `TRANSACCIÓN DE ${LABELTEXT.toUpperCase()}` : status === 7 ? `DEVOLUCIÓN DE ${LABELTEXT.toUpperCase()}` : `ENTREGA DE ${LABELTEXT.toUpperCase()}`} modal className="p-fluid" footer={tabletDialogFooter} closable={false} onHide={() => { onHide(); setNumTablets(0); }} draggable={false}>
                <Toast ref={toast} />

                <div className='grid'>

                    {/* INICIO ENCABEZADO DE DATOS */}
                    <div className='grid col-12 p-2 mr-2 ml-2' style={{ marginTop: '10px' }}>
                        {lstAlmacenCT.map((items, index) => {

                            if (items.IdTienda === idTiendaDestino) {

                                return (
                                    status !== 3 ? '' :
                                        <div key={index} className="border-1 row col-12  border-500 border-round">
                                            <div className='col-12 text-center' style={{ paddingBottom: 0 }}>
                                                <h6 className="bg-gray" style={{ textAlign: 'center', marginTop: '-23px', background: '#ffffff', width: '175px' }}>DATOS DEL DESTINO</h6>
                                            </div>
                                            {parseInt(process.env.REACT_APP_SISTEMA) !== 1 ?
                                                <>
                                                    <div className='col-4'>
                                                        <label><strong>Escuela: </strong>  {items.Escuela}</label><br />
                                                        <label><strong>Nivel: </strong> {items.Nivel}</label><br />
                                                        <label><strong>Supervisión: </strong> {items.Supe}</label><br />
                                                        {/* <label><strong>Total de tablets: </strong> {items.TotalTabletsEntregadasaCT}</label><br /> */}
                                                    </div>
                                                    <div className='col-4'>
                                                        <label><strong>Alumnos a entregar: </strong>{items.TotalAlumnos}</label><br />
                                                        <div><label><strong>Personal a entregar: </strong> {items.TotalTabletasExtras}</label><br /> </div>

                                                        {/*<label><strong>Total de alumnos entregados: </strong> {items.TotalAlumnoEntregados}</label><br />*/}
                                                        {/* <label><strong>Total de alumnos pendientes de entregar: </strong> {items.AlumnosFaltantes}</label><br /> */}

                                                    </div>
                                                    <div className='col-4'>
                                                        <label><strong>Total a enviar a CT: </strong> {items.TotalAlumnos + items.TotalTabletasExtras}</label><br />
                                                        <label><strong>Enviados a CT:</strong> {items.TotalTabletasEntregadasaCT}</label><br />

                                                        {/*<label><strong>{`Total de ${LABELTEXT.toLowerCase()} faltantes: `}</strong>{items.AlumnosFaltantes}</label><br />*/}
                                                        {/* <label><strong>Total de tablets regresadas: </strong> {items.TotalRegresadas}</label><br /> */}

                                                    </div>
                                                </> :
                                                <>
                                                    <div className='col-12 grid'>
                                                        <div className="col-4 justify-content-start"><label><strong>Escuela: </strong>  {items.Escuela}</label></div>
                                                        <div className="col-4 justify-content-center"><label><strong>Nivel: </strong> {items.Nivel}</label></div>
                                                        <div className="col-4 justify-content-end"><label><strong>Supervisión: </strong> {items.Supe}</label></div>
                                                        {/* <label><strong>Total de tablets: </strong> {items.TotalTabletsEntregadasaCT}</label><br /> */}
                                                    </div>
                                                    <div className='col-12'>
                                                        <DataTable id="TablaProgramaSeleccionar" value={JSON.parse(items.JsonPrendas)} scrollable scrollHeight="170px" size="small" showGridlines>
                                                            <Column header='Prenda' body={e => <label>{e.Prenda} ({e.CodigoPT.slice(0, 2)})</label>} />
                                                            <Column header='Talla' field="Talla" />
                                                            <Column header='Genero' field="Genero" />
                                                            <Column header='Total a entregar' field="Total" />
                                                            <Column header='Total a entregado' field="TotalEntregado" />
                                                        </DataTable>

                                                    </div>
                                                </>
                                            }
                                        </div>

                                )

                            }

                        })
                        }
                    </div>
                    {/* FIN ENCABEZADO DE DATOS */}

                    <div className='col-12 md:col-6 lg:col-3'>
                        <h6>Destino</h6>
                        <Dropdown value={idTiendaDestino} onChange={(e) => { setIdTiendaDestino(e.value) }} options={lstAlmacenCT} optionLabel="Tienda" optionValue="IdTienda" placeholder="Seleccione un destino" emptyMessage="No hay destinos disponibles." emptyFilterMessage="No hay destinos disponibles."
                            filter valueTemplate={selectedCT} itemTemplate={optionCT} />
                    </div>
                    <div className='col-12 md:col-6 lg:col-9'>
                        <h6 style={{ display: 'flex' }}><label style={{ color: 'red' }}>*&nbsp;</label> Observaciones</h6>
                        <InputText value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
                    </div>


                    <div className="col-12">
                        <div className="grid mt-3">
                            <div className="col-12">
                                <form onSubmit={seleccionarTabletas2}>
                                    <div className="grid mb-2">
                                        <div className="col-10 text-left" style={{ display: 'flex' }}>
                                            <h6 style={{ display: 'flex', marginBottom: 0 }}><label style={{ color: 'red' }}>*&nbsp;</label> Agregar {LABELTEXT_S.toLowerCase()}s</h6>
                                            {parseInt(process.env.REACT_APP_SISTEMA) !== 1 && <h6 style={{ marginLeft: '10px', marginTop: '0px', marginBottom: 0, color: 'red' }}>{numTablets < 0 ? `Ha excedido el límite de ${LABELTEXT.toLocaleLowerCase()} a entregar, favor de remover.` : ' '}</h6>}
                                        </div>
                                        {status === 3 && parseInt(process.env.REACT_APP_SISTEMA) !== 1 && <div className="col-2 text-right"><label style={{ color: '#9B2F3E', fontWeight: '500' }}>Por entregar: {numTablets}</label></div>}
                                    </div>
                                    <div className="md:flex lg:flex">
                                        {/* <CustomSelect
                                            className='w-full md:w-11 lg:w-11'
                                            autofocus
                                            id={'serie'}
                                            defaultValue={''}
                                            placeholder={`Buscar serie`}
                                            noOptionsMessage={'No se encontraron incidencias.'}
                                            options={lstBaseDatos}
                                            value={tablet.serie}
                                            onChange={(value) => { parseInt(process.env.REACT_APP_SISTEMA) === 2 ? setTablet({ ...tablet, serie: value.value.serie }) : setTablet({ ...tablet, serie: value.value.CodigoPrenda + value.value.CodigoTalla + value.value.serie }); }} /> */}
                                        <InputText value={tablet.serie} onChange={(e) => setTablet({ ...tablet, serie: e.target.value })} />
                                        <Button type="submit" label="Agregar" icon='pi pi-plus' className="p-button w-full mt-3 md:w-auto lg:w-auto md:ml-3 lg:ml-3 md:mt-0 lg:mt-0" />
                                        {parseInt(process.env.REACT_APP_SISTEMA) === 1 && <Button type="button" label="Escaner" icon='pi pi-qrcode' className="p-button w-full mt-3 md:w-auto lg:w-auto md:ml-3 lg:ml-3 md:mt-0 lg:mt-0" onClick={() => setScannerDialog(true)} />}
                                    </div>
                                </form>
                            </div>
                            <div className='col-12'>
                                <DataTable value={selectedTablets} showGridlines id="tb-tablets" dataKey="serie"
                                    paginator rows={5} paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                    currentPageReportTemplate="De {first} hasta {last} de {totalRecords}"
                                    emptyMessage={<label>{`Sin ${LABELTEXT.toLowerCase()} escaneadas`}</label>}>
                                    {/* <Column header='Código' field='IdAlmacen' /> */}
                                    <Column header='Descripción' field="Prenda" />
                                    <Column header='Talla' field='CodigoTalla' />
                                    <Column header='Serie' body={serieConcatenada} />
                                    <Column header="Remover" body={retiroBodyTemplate} />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
                <Sidebar fullScreen visible={loading1} style={{ background: 'lightgray', opacity: '60%' }} showCloseIcon={false}>
                    <div className="text-center" style={{ marginTop: '200px' }}>
                        <ProgressSpinner />
                        <div className="col-12" style={{ color: 'black', fontSize: '14px' }}><strong>Cargando...</strong></div>
                    </div>
                </Sidebar>
            </Dialog >
            <Dialog visible={displayDalogAviso} header='AVISO' closable={false} draggable style={{ width: '40%' }} footer={avisoFooterTemplate}>
                <div className="m-3 text-center">
                    <h5>Imprimiendo recibo.</h5>
                </div>
            </Dialog>
            <Dialog header='ESCANER' visible={scannerDialog} style={{ width: "40%" }} closable={false} draggable={false} footer={scannerFooterTemplate} >
                <ScannerEntrega alumnoRow={{ IdAlumno: -1 }} onResult={(e) => { seleccionarTabletasQR2(e.Serie) }} onHide={() => setScannerDialog(!scannerDialog)} />
            </Dialog>
        </>
    )
}

export default TransaccionTablet;